<div class="image-recording" style="width: 100% !important;">
    <webcam [height]="200" 
    [width]="200"  [trigger]="triggerObservable" id="login-video" (imageCapture)="handleImage($event)" (initError)="handleInitError($event)"></webcam>
</div>